import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../store/auth-context';
import LoginStyle from '../../Styles/Login.module.css';
import ButtonStyle from '../../Styles/Button.module.css';
import { FaCheck } from "react-icons/fa6";
import { LoginOTPSubmit, LoginOTPVerifySubmit } from '../../../services/routes.services';
import SignUpScreen from './SignUp';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
const LoginScreen = ({ url, pageName, onClose }) => {
  const [forgotMsg, setForgotMsg] = useState(false);  // State to toggle between login and signup
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    otp_session_id: '',
  });
  const [errorMsg, setErrorMsg] = useState('');
  const [method, setMethod] = useState('phone');
  const [phone, setPhone] = useState('');
  const [otpEmail, setOtpemail] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState('form');

  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  // OTP login handler
  const loginHandler = async () => {
    setErrorMsg('');
  
    if (
      (method === 'phone' && (!phone || phone.length < 10)) ||
      (method === 'email' && !/\S+@\S+\.\S+/.test(otpEmail))
    ) {
      setErrorMsg('Please enter a valid ' + method);
      return;
    }
  
    let postData = {};
    if (method === 'phone') {
      postData = {
        u_phone: `+91${phone}`,
        session: formData.otp_session_id,
      };
    } else {
      postData = {
        u_email: otpEmail,
        session: formData.otp_session_id,
      };
    }
  
    try {
      const response = await LoginOTPSubmit(postData);
      setFormData((prev) => ({
        ...prev,
        otp_session_id: response.data.otp_session_id,
      }));
      if(response.data.message === "OTP sent successfully."){
        const userData = {
          token:response.data.token
        }
        
        console.log('OTP Login Success:', response.data);
        setStep('otp');
      }
      
    } catch (error) {
      setErrorMsg(error.response?.data?.message || 'Login failed. Try again.');
      console.error('OTP Login Error:', error.response?.data || error.message);
    }
  };
  

  // OTP verification handler
  const LoginVerifyOTPHandler = async (e) => {
    e.preventDefault();
    setErrorMsg('');
  
    if (!otp || otp.length < 6) {
      setErrorMsg('Please enter a valid OTP');
      return;
    }
  
    const postData = method === 'phone'
      ? { u_phone: `+91${phone}`, otp: otp, session: formData.otp_session_id }
      : { u_email: otpEmail, otp: otp, session: formData.otp_session_id };
  
    try {
      const response = await LoginOTPVerifySubmit(postData);
      console.log('OTP Verification Success:', response.data);
      if(response.data.message === "Login successful.") {
        const userData = {
          token: response.data.token,
          u_msg: response.data.message,
          u_email: response.data.user.u_email,
          u_number: response.data.user.u_phone,
          u_name: response.data.user.u_name,
        }
        authCtx.login(userData);
        navigate('/searchResult');
        onClose(); 
        toast.success(response.data.message);
      } else {
        navigate('');
      }
    } catch (error) {
      setErrorMsg(error.response?.data?.message || 'OTP verification failed. Try again.');
      console.error('OTP Verification Error:', error.response?.data || error.message);
    }
  };
  const goLoginHandler = () => {
    setForgotMsg(false);
  };

  // Show signup form
  const goSignUpHandler = () => {
    setForgotMsg(true); 
  };

  return (
    <div className={LoginStyle.loginBox}>
      <div className={LoginStyle.loginContainer}>
      <span className={LoginStyle.closeBox} onClick={onClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path d="M23.6795 10.5306L10.0306 24.1795M10.0306 10.5306L23.6795 24.1795M32.2101 17.355C32.2101 25.8354 25.3354 32.7101 16.855 32.7101C8.37469 32.7101 1.5 25.8354 1.5 17.355C1.5 8.87469 8.37469 2 16.855 2C25.3354 2 32.2101 8.87469 32.2101 17.355Z" stroke="black" strokeWidth="2.05917" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>

        <h3>{forgotMsg ? 'Sign Up' : 'Login'}</h3>

        <div className={LoginStyle.loginStyle}>
          <div className={LoginStyle.loginImg}>
            <img src={require('../../../assest/images/loginImg.jpg')} alt='Login' />
          </div>

          <div className={LoginStyle.loginFomrStyle}>
            {forgotMsg ? (
              <>
                <SignUpScreen  setForgotMsg={setForgotMsg} onClose={onClose}  />
                
              </>
            ) : step === 'form' ? (
              <>
                <h4>Welcome</h4>
                <p>Enter your details to login</p>
                {/* <div className="radioBtn">
                  <button onClick={() => setMethod('phone')} className={method === 'phone' ? 'active' : 'inactive'}>
                    <span className={LoginStyle.check}><FaCheck /></span> Phone
                  </button>
                  <button onClick={() => setMethod('email')} className={method === 'email' ? 'active' : 'inactive'}>
                    <span className={LoginStyle.check}><FaCheck /></span> Email
                  </button>
                </div> */}

                {method === 'phone' ? (
                  <div className={`${LoginStyle.inputFeild} ${LoginStyle.num}`}>
                    <span>+91</span>
                    <input type="tel" placeholder="Mobile Number" value={phone} onChange={(e) => setPhone(e.target.value)} />
                    {errorMsg && <div className={LoginStyle.errorMsg}>{errorMsg}</div>}
                  </div>
                ) : (
                  <div className={LoginStyle.inputFeild}>
                    <input type="email" placeholder="Email" value={otpEmail} onChange={(e) => setOtpemail(e.target.value)} />
                    {errorMsg && <div className={LoginStyle.errorMsg}>{errorMsg}</div>}
                  </div>
                )}
                <button onClick={loginHandler} className={`${ButtonStyle.largeButton} ${ButtonStyle.roundStyle} ${ButtonStyle.orangeStyle}`}>Get OTP</button>
                <p className={LoginStyle.accountText}>Don't have an account? <a onClick={goSignUpHandler} title="Having trouble in sign in?">Register now</a></p>
              </>
            ) : (
              <div className={LoginStyle.regOtp}>
                <h4>Enter OTP</h4>
                <div className={LoginStyle.inputFeild}>
                  <input type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
                  {errorMsg && <div className={LoginStyle.errorMsg}>{errorMsg}</div>}
                </div>
                <input type="hidden" value={formData.otp_session_id} name="session" />
                <button onClick={LoginVerifyOTPHandler} className={`${ButtonStyle.largeButton} ${ButtonStyle.roundStyle} ${ButtonStyle.orangeStyle}`}>Verify OTP</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
